(function () {
  'use strict';

  function addBusinessDays(date, days) {
    var result = new Date(date);
    var added = 0;
    while (added < days) {
      result.setDate(result.getDate() + 1);
      var dow = result.getDay();
      if (dow !== 0 && dow !== 6) added++;
    }
    return result;
  }

  // Locale active de la boutique (Shopify Markets), passée par le snippet via data-locale.
  function resolveLocale(block) {
    return block.getAttribute('data-locale') || document.documentElement.lang || 'fr';
  }

  // Dates localisées automatiquement selon la langue active — aucun mois codé en dur.
  function formatDate(date, locale) {
    try {
      return new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'long' }).format(date);
    } catch (e) {
      return new Intl.DateTimeFormat('fr', { day: 'numeric', month: 'long' }).format(date);
    }
  }

  function initBlock(block) {
    var deliveryRow = block.querySelector('[data-wbdi-delivery]');
    var deliveryText = block.querySelector('[data-wbdi-delivery-text]');

    if (!deliveryRow || !deliveryText) return;

    var delayMin = parseInt(block.getAttribute('data-delay-min'), 10) || 2;
    var delayMax = parseInt(block.getAttribute('data-delay-max'), 10) || 4;
    var prefix = block.getAttribute('data-prefix') || 'Livraison entre le';
    var connector = block.getAttribute('data-connector') || 'et le';
    var locale = resolveLocale(block);

    var now = new Date();
    var dateMin = addBusinessDays(now, delayMin);
    var dateMax = addBusinessDays(now, delayMax);

    deliveryText.innerHTML = prefix + ' <strong>' + formatDate(dateMin, locale) + '</strong> ' + connector + ' <strong>' + formatDate(dateMax, locale) + '</strong>';
  }

  function init(container) {
    var blocks = container.querySelectorAll('[data-wbdi-block]');
    blocks.forEach(function (block) { initBlock(block); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

})();